module.exports = __webpack_public_path__ + "static/img/immortal 2.d566269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 2.png
// module id = AsNm
// module chunks = 35